module.exports = __webpack_public_path__ + "img/form-lower-title-desktop.5956c207.png";